<template>
  <div id="striiv-sleep-graph">
    <mu-paper>
      <striiv-sleep-chart
        v-if="hasSleepData && !isLoading"
        :chart-data="data"
        :options="options"
      ></striiv-sleep-chart>
      <mu-card-text v-if="!isLoading && !hasSleepData">
        <alert type="info" icon="info">
          <div slot="content">
            Not enough data to create a chart
          </div>
        </alert>
      </mu-card-text>
    </mu-paper>
  </div>
</template>

<script>

  import Alert from "../../../Alert/Alert.vue";
  import StriivSleepChart from '../../../Tracking/Graph/StriivSleep';

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    bezierCurve: true,
    legend: {
      display: false
    },
    layout: {
      padding: {
        top: 40
      }
    },
    tooltips: {
      mode: 'nearest',
      intersect: false
    },
    elements: {
      line: {
        tension: 0.5
      }
    },
    scales: {
      xAxes: [{
        gridLines: {
          display: false,
          color: '#738F9A',
          zeroLineColor: "transparent",
          borderDash: [1, 10],
          drawBorder: true
        },
        display: true,
        scaleLabel: {
          display: true,
        },
        time: {
          unit: 'minute',
          stepSize: 2,
          source: 'auto'
        },
        ticks: {
          autoSkip: true,
          autoSkipPadding: 60,
          maxRotation: 0,
          minRotation: 0
        }
      }],
      yAxes: [{
        gridLines: {
          display: true,
          color: '#738F9A',
          zeroLineColor: "transparent",
          borderDash: [1, 10],
          drawBorder: false
        },
        type: 'category',
        position: 'left',
        display: true,
        scaleLabel: {
          display: true
        }
      }]
    }
  };

  export default {
    name: 'striiv-sleep-graph',
    components: {
      StriivSleepChart,
      Alert
    },
    props: {
      striivData: {
        type: Object,
        defaut: {}
      },
    },
    data() {
      return {
        isLoading: true,
        sleepData: {},
        data: {},
        options: options
      }
    },
    methods: {
      dateToLocalTime(date) {
        var date = moment.utc(date).local();
        return date.format('HH:mm a');
      },
    },
    mounted() {
      let self = this;
      self.isLoading = true;

      self.sleepData = self.striivData;

      if(self.hasSleepData) {

        let levels = self.sleepData;
        let length = levels.length;
        let labels = [];
        let pointBackgrounds = [];
        let graphData = {
          xLabels: [],
          datasets: []
        };

        if(self.sleepData[0].totals.awake === 0) {
          graphData.yLabels =  ['', 'Light', 'Deep', ''];
        } else {
          graphData.yLabels =  ['', 'Awake', 'Light', 'Deep', ''];
        }

        let dataset = {
          label: "Sleep",
          data: [],
          fill: false,
          borderWidth: 4,
          borderColor: '#17343A',
          pointBackgroundColor: ['transparent'],
          pointRadius: 0,
          steppedLine: true
        };

        for (let i = 0; i < length; i++) {
          pointBackgrounds.push();
          labels.push(self.dateToLocalTime(levels[i].date));
          dataset.data.push(_.startCase(levels[i].state));
        }

        graphData.xLabels = labels;
        graphData.datasets = [dataset];

        self.data = graphData;
        self.$forceUpdate();
      }
      self.isLoading = false;

    },
    computed: {
      hasSleepData() {
        let self = this;
        if(self.sleepData.length) {
          return true;
        } else {
          return false;
        }
      }
    }
  }

</script>

<style lang="less">
  #striiv-sleep-graph {
    .alert {
      display: block;
      max-width: 300px;
      margin: 120px auto;
    }
  }

</style>



// WEBPACK FOOTER //
// StriivSleepGraph.vue?11a0242e